import { FaCheck, FaRegQuestionCircle, FaTimes } from 'react-icons/fa';
import { useEffect, useMemo } from 'react';
import { MappingState } from 'types/MappingState';
import { StaticAttribute } from '../../../types/StaticAttribute';
import { Tooltip } from '@material-ui/core';

interface SocialNameValidationProps {
  mappingState: MappingState;
  socialNameAttributes: StaticAttribute[];
  setSocialNameValidationResult: (result: boolean) => void;
}
export const SocialNameValidation = ({mappingState, socialNameAttributes, setSocialNameValidationResult}: SocialNameValidationProps) => {

  
  const isNoneSocialNameAttributesMapped = useMemo(() => {
    return socialNameAttributes.every(attribute => {
      const attr = mappingState.staticAttributes[attribute.id];
      const value = attr?.value;

      if (value === undefined) return false;

      return value.length === 0;
    });
  }, [mappingState.staticAttributes, socialNameAttributes]);

  const isIntersectionBetweenSocialNameAttributesMapped = useMemo(() => {
    const socialNameUsedValues = socialNameAttributes
      .flatMap(attribute => mappingState.staticAttributes[attribute.id]?.value || []);
    const socialNameUsedValuesUnique = [...new Set(socialNameUsedValues)];

    return socialNameUsedValuesUnique.length !== socialNameUsedValues.length;
  }, [mappingState.staticAttributes, socialNameAttributes]);

  useEffect(() => {
    if (isNoneSocialNameAttributesMapped)
      setSocialNameValidationResult(true);
    else if (isIntersectionBetweenSocialNameAttributesMapped)
      setSocialNameValidationResult(true);
    else
      setSocialNameValidationResult(false);
  }, [isIntersectionBetweenSocialNameAttributesMapped, isNoneSocialNameAttributesMapped, setSocialNameValidationResult]);

  const isIntersectionNecessary = useMemo(() => {
    return !isNoneSocialNameAttributesMapped;
  }, [isNoneSocialNameAttributesMapped]);
  
  return (
    <span style={{ display: 'flex', alignItems: 'center' }}>
      {!isNoneSocialNameAttributesMapped && (
        <>
          <span style={{ fontWeight: 'bold', color: '#0C326F' }}>Validações:</span>
          <span style={{ fontSize: '0.85rem', marginLeft: '1rem', display: 'flex', flexDirection: 'column' }}>
          {isIntersectionNecessary && (
            <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: isIntersectionBetweenSocialNameAttributesMapped ? 'green' : 'red', }}>
              <span>{isIntersectionBetweenSocialNameAttributesMapped ? <FaCheck /> : <FaTimes />}</span>
              <span style={{textAlign: 'justify'}}>Os atributos do composição e nome social devem ter pelo menos um valor em comum</span>
              <Tooltip title={'"Nome Social" deve conter o atributo que representa o nome social do usuário e "Composição do nome social" deve conter um ou mais atributos que representam o nome social e sobrenome.'} arrow>
                 <span><FaRegQuestionCircle size={18} style={{ color: '#0C326F' }} /></span>
              </Tooltip>
            </span>
          )}
          </span>
        </>
    )}
   </span>
  );
};